import { CSSProperties } from 'react';
import { UserInitialsBadge } from '@dealstack/frontend/shared/components/UserInitialsBadge/UserInitialsBadge';
import { Flex, Text, type TextProps } from '@mantine/core';

interface Props {
	firstName?: string;
	lastName?: string;
	subText?: string;
	text?: string;
	avatarSize?: CSSProperties['height'];
	avatarTextSize?: TextProps['fz'];
}

export const AvatarInfoRow = ({
	firstName,
	lastName,
	text,
	subText,
	avatarSize,
	avatarTextSize,
}: Props) => {
	return (
		<Flex gap="0.5rem" align="center" w="100%">
			<UserInitialsBadge
				firstName={firstName}
				lastName={lastName}
				size={avatarSize}
				textVariant={avatarTextSize}
			/>

			<Flex
				direction="column"
				w="100%"
				sx={(theme) => ({
					overflow: 'hidden',
					'& > :last-of-type': {
						color: theme.colors.dark[0],
					},
				})}
			>
				{text && (
					<Text variant="p-sm" truncate lineClamp={1}>
						{text}
					</Text>
				)}
				<Text variant="p-sm" truncate lineClamp={1}>
					{subText}
				</Text>
			</Flex>
		</Flex>
	);
};
